export default {
  fields: {
    price: 'Cena',
    tax: 'Podatek',
    visible_to: 'Widoczna dla',
  },
  buttons: {
    add_price: '+ Dodaj cenę',
  },
};
